import React from 'react';
import { IAccessoryOrder, IRelatedItem } from '../../../models/product-detail';
import Gallery from '../../common/gallery';
import AccessoryElement from './accessory-element';

interface Props {
    label: string;
    accessories: IRelatedItem[];
    selectedAccessories: IAccessoryOrder[];
    onAddDeleteAccessory: (partNumber: string, quantity: number) => void;
    patientOrder: boolean;
}

const responsive = {
    0: { items: 1 },
    1024: { items: 4 },
};

const RelatedItemsCarousel: React.FC<Props> = ({
    label,
    accessories,
    selectedAccessories,
    onAddDeleteAccessory,
    patientOrder,
}) => {
    return (
        <div>
            <div className="col-md-12 row-m-b">
                <h4>{label}</h4>
            </div>
            <div className="col-md-12 row-m-b">
                <Gallery
                    responsive={responsive}
                    items={accessories.map((accessory) => {
                        const selectedAccessory = selectedAccessories.find(
                            (x) => x.partNumber === accessory.partNumber
                        );
                        return (
                            <React.Fragment key={accessory.partNumber}>
                                <AccessoryElement
                                    accesoryName={accessory.description}
                                    productNumber={accessory.partNumber}
                                    imageUrl={accessory.imagePath}
                                    quantity={
                                        selectedAccessory
                                            ? selectedAccessory!.quantity
                                            : 0
                                    }
                                    onQuantityChanged={onAddDeleteAccessory}
                                    itemGuid={accessory.itemGuid}
                                    patientOrder={patientOrder}
                                />
                            </React.Fragment>
                        );
                    })}
                />
            </div>
        </div>
    );
};

export default RelatedItemsCarousel;
